
import React from 'react';
import { Button } from '@punchcard/core/components/Button';
import { IconAddWorkSample, IconRedWarning, IconRemoveWorkSample } from '@punchcard/core/icons';
import { useTranslation } from 'react-i18next';
import { Tooltip } from 'react-tooltip';

interface IPageButtonProps {
	selectedPages?: number[] | undefined;
	handleAddToSample: (index: number) => void;
	index?: number;
	isFinalGrade?: boolean;
	includeItem?: boolean;
	isPreparing?: boolean;
}

const PageButton = (props: IPageButtonProps) => {
	const { selectedPages, handleAddToSample, index, isFinalGrade, includeItem, isPreparing } = props;
	const { t } = useTranslation();
	return (
		<div>
			{isFinalGrade && <div
				className=" bg-danger-100 rounded-3 p-2 mb-2 d-flex align-items-center justify-content-center me-auto" style={{ width: '200px' }}
			>
				<IconRedWarning className="icon-22 text-danger-600 me-2" />
				<p className="mb-0">{t('worksample.part_of_final_grade')}</p>
			</div>
			}
			{isPreparing && (
				<Tooltip id={`tooltip-${index}`} place="top-start" />
			)}
			<span
				data-tooltip-id={`tooltip-${index}`}
				data-tooltip-content={t('worksample.you_cannot_make_changes_work_sample')}
			>

				<Button className="addsample-button"
					onClick={() => handleAddToSample((index ?? 0) + 1)}
					disabled={props.isPreparing}
				>
					{includeItem || (selectedPages && selectedPages.includes((index ?? 0) + 1)) ?
						<React.Fragment>
							<IconRemoveWorkSample className="icon-22" />
							<span className="ms-1">{t('worksample.remove_from_sample')}</span>
						</React.Fragment>
						:
						<React.Fragment>
							<IconAddWorkSample className="icon-22" />
							<span className="ms-1">{t('worksample.add_to_sample')}</span>
						</React.Fragment>
					}
				</Button>
			</span>
		</div>
	);
};
export default PageButton;